export class ChatConfig {
  public static EndPoint = {
    chat: {
      getUserMessage: '/socket/getUserMessage',
      getUserConversation: '/socket/getUserConversation',
      getChatUsers: '/socket/getChatUsers/{id}',
      getChatUsersByCase: '/socket/getChatUsersByCase',
      getAllChatUsers: '/integration/getChatUser',
      getChildByCase: '/integration/getChildByCase/{case_id}',
      addChatUsers: '/socket/addChatUsers',
      getCaseList: '/integration/getCaseList',
      getUnreadMessages: '/socket/getUnreadMessages',
      getUserSession: '/socket/getUserSession/{id}',
      getOnlineUsers: '/socket/getOnlineUsers'
    },
    document: {
      getSignedDocumentUrl: '/socket/getSignedDocument',
      updateDocumentStatus: '/documentattachment/ApproveOrRejectAttachment/{document_id}',
      getAttachmentById: '/documentattachment/getAttachmentById/{document_id}',
      getDocumentCategories: '/lookup/getType/DTY',
      getDocumentTypes: '/lookup/getType/DTY/{key}',
      addAttachment: '/documentattachment/addAttachment',
    }
  };
}
